import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class AutorizaRotaService {
  private permissoes!: any[];

  constructor(private storage: StorageService) {
    this.permissoes = this.storage.getPermissoes();
  }

  temAcessoRota(id_rota: number): boolean {
    // Verifique se o usuário tem acesso ao menu com base no array de permissões
    return this.permissoes.some((permissao) => permissao.id_menu === id_rota);
  }
}
